import type { Viewer } from '@beacon/core';

import type { BeaconClient } from '../client.js';

export interface MeResponse {
  viewer: Viewer;
}

export const authApi = {
  /** Resolve the current viewer from the session / dev header. */
  me(client: BeaconClient): Promise<MeResponse> {
    return client.get<MeResponse>('/auth/me');
  },
};
